export const getMetricUniqueKey = (m: { metric_id: number; asset_value?: string }) =>
  [m.metric_id, m.asset_value].filter(Boolean).join(",");
